import { InitRecordSchema } from "slotworks/integration/revolver/schema/init-record-schema";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import Record from "slotworks/model/gameplay/records/record";
import settingsModel from "slotworks/model/settings/settings-model";

class IcPaytableRecordBuilder implements RecordBuilder {

    public filter(data: any): boolean {
        let initRecord: InitRecordSchema;

        if (data && data.data) {
            initRecord = data.data as InitRecordSchema;
        }

        return initRecord && initRecord.AUTH !== undefined;
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let initRecord: InitRecordSchema;

        if (data && data.data) {
            initRecord = data.data as InitRecordSchema;            
        }

        const paytable = (initRecord.CONFIG as any).payTableConfig;

        if(paytable && paytable.rtp) {
            const rtp = paytable.rtp.total;

            (settingsModel as any).rtp_total = rtp;
        }

        return [];
    }
}

export default new IcPaytableRecordBuilder();